import { FEATURE_STATUS } from "./constant";
import { getParamUrl } from "./url";

export function getFeatureStatus(key) {
  if (!window.location.search.includes(key)) return FEATURE_STATUS.UNKNOW;

  let params = getParamUrl(key);
  if (!params) {
    return FEATURE_STATUS.UNKNOW;
  }

  if (params === "off" || params === "0") {
    return FEATURE_STATUS.DEACTIVE;
  }

  if (params === "on" || params === "1") {
    return FEATURE_STATUS.ACTIVE;
  }

  return FEATURE_STATUS.UNKNOW;
}

export function isFeatureActive(key) {
  return getFeatureStatus(key) === FEATURE_STATUS.ACTIVE;
}

export function isFeatureDeactive(key) {
  return getFeatureStatus(key) === FEATURE_STATUS.DEACTIVE;
}

export function isFeatureUnknow(key) {
  if (!window.location.search.includes(key)) return true;
  return getFeatureStatus(key) === FEATURE_STATUS.UNKNOW;
}

export function handleFeatureCallback({ listKey, onUnknow = () => { }, onDeactive = () => { }, onActive = () => { } } = {}) {
  for (let index = 0; index < listKey.length; index++) {
    const key = listKey[index];
    let status = getFeatureStatus(key);

    if (status === FEATURE_STATUS.UNKNOW) {
      typeof onUnknow === "function" && onUnknow(key);
      continue;
    }
    if (status === FEATURE_STATUS.DEACTIVE) {
      typeof onDeactive === "function" && onDeactive(key);
      continue;
    }
    if (status === FEATURE_STATUS.ACTIVE) {
      typeof onActive === "function" && onActive(key);
      continue;
    }
  }
}


